<template>
  <div class="bindUser" v-if="getUserDataState">
    <!-- 进度条模块 -->
    <div class="bindUserBox" v-if="pageType === 0">
      <!-- 步骤条 -->
      <div class="steps flex-c f_14">
        <div v-if="headerType==='qrcode'" class="item flex-c color_9c color_blue active"><div class="number text_center">1</div><div class="flex1">绑定微信账号</div></div>
        <div v-else class="item flex-c color_9c color_blue active"><div class="number text_center">1</div><div class="flex1">绑定联系方式</div></div>
        <div class="step text_center active" :class="{'magin-20': stepId===3}">
          <div class="pr">
            <span v-for="item in 6" :key="item"></span>
          </div>
        </div>
        <div class="item flex-c color_9c" :class="[stepId===1 || stepId===2 || stepId===3 ?'color_blue active' :'']"><div class="number text_center">2</div><div class="flex1">完善个人信息</div></div>
        <div class="step text_center active" :class="{'magin-20': stepId===3}" v-if="stepId===3">
          <div class="pr">
            <span v-for="item in 6" :key="item"></span>
          </div>
        </div>
        <div v-if="stepId===3" class="item flex-c color_9c" :class="[stepId===3 ? 'color_blue active' :'']"><div class="number text_center">3</div><div class="flex1">确认公司信息</div></div>
<!--        <div class="step text_center" :class="[stepId===1 || stepId===2?'active' :'']">-->
<!--          <div class="pr">-->
<!--            <span v-for="item in 6" :key="item"></span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="item flex-c color_9c" :class="[stepId===2 || stepId===2?'color_blue active' :'']"><div class="number text_center"><i class="iconfont iconziyuanldpi"></i></div><div class="flex1">注册成功</div></div>-->
      </div>

      <!-- 绑定微信 -->
      <div class="qrCodeContent phoneContent bg_fff" v-if="stepId===-1">
        <div class="top">
          <div class="title f_16 color_40 font_w_b text_center">关注公众号</div>
          <div class="text f_14 color_9c text_center">扫码关注，查看人才推荐&投递消息</div>
        </div>

        <div class="qrCode pr">
          <img :src="qrCodeData.url" alt="" class="qrCodeImg" v-show="qrCodeData.url">
          <img src="https://files.wondercv.com/auth/qrcode_reload.png" alt="" class="qrCodeReload pa cursor_p" @click="getQrcode()" v-if="qrCodeData.checkSize<1">
        </div>

        <div class="skip-button" @click="stepId = 1">跳过</div>

        <p class="overflow-text">注册成功后即可免费下载候选人简历，无限邀约  <span @click="errorMessage" class="customer">联系客服</span></p>
      </div>

      <!-- 绑定手机号 -->
      <div class="phoneContent bg_fff" v-if="stepId===0">
        <div class="top">
          <div class="title f_16 color_40 font_w_b">绑定联系方式</div>
          <div class="text f_14 color_9c">便于快捷登录及人才沟通</div>
        </div>

        <!-- 手机号登录样式 -->
        <div class="phoneFormBox">
          <div class="formItem flex-c">
            <div class="phoneType f_14 color_40">+86</div>
            <div class="pr flex1">
              <input type="text" class="input f_16 color_40" v-model="phoneData.phone" placeholder="输入手机" maxlength="11">
            </div>
          </div>
          <div class="formItem flex-c">
            <div class="flex1 pr">
              <input type="text" class="input f_16 color_40" v-model="phoneData.phone_token" placeholder="请输入验证码" maxlength="6" >
            </div>
            <div class="getCode cursor_p text_center f_14">
              <span class="color_blue" @click="checkCode()" v-if="phoneData.time === 60">发送验证码</span>
              <span class="color_blue" v-else >重新获取({{phoneData.time}}s)</span>
            </div>
          </div>

          <div class="submitButton cursor_p color_fff text_center bg_current f_16" @click="updateInfo()">确认绑定</div>
          <div class="errorMessage f_14 color_9c" @click="errorMessage">登录遇到问题?</div>
        </div>

      </div>
      <!-- 完善用户信息 -->
      <div class="userinfo bg_fff" v-if="stepId===1">
        <!-- 顶部模块 -->
        <div class="top pr">
          <div class="title f_18 color_40 font_w_b">完善个人信息</div>
          <div class="text f_14 color_9c">完善后即可免费下载完整简历</div>
          <div v-if="!this.userJWT.c_t" class="jump pa f_14 color_9c cursor_p" @click="routerBack(true)">跳过</div>
        </div>
        <!-- 表单 -->
        <div class="form">
          <dl class="formItem flex">
            <dt class="f_14 color_60"><span>姓名</span>：</dt>
            <dd class="flex1">
              <el-input class="restInput f_14 color_40" v-model="userFormNew.name" placeholder="请输入你的姓名" :maxlength="10"></el-input>
            </dd>
          </dl>
          <dl class="formItem flex">
            <dt class="f_14 color_60"><span>职位</span>：</dt>
            <dd class="flex1">
              <el-input class="restInput f_14 color_40" v-model="userFormNew.company_position" placeholder="请输入你的职位" :maxlength="20" ></el-input>
            </dd>
          </dl>
          <dl class="formItem flex pr" :class="[errorTips.company_name && userInfo.status == 0 ? 'errorTips':'']">
            <dt class="f_14 color_60"><span>公司名称</span>：</dt>
            <dd :class="['flex1',{'company-name' : userFormNew.company_name}]">
              <!-- 智能联想 -->
              <el-autocomplete :disabled="userInfo.status == 2" class="restInput f_14 color_40" popper-class="searchCompany" :maxlength="20" placeholder="请输入你的公司名称" v-model="userFormNew.company_name" :fetch-suggestions="companySearch" @select="handleCompany">
                <template slot-scope="{item}">
                  <div class="name" v-if="item.full_name && item.full_name.length">
                    <template v-if="item.full_name.length===1 && searchIngCompanyList[item.index].full_name===userFormNew.company_name">
                      <span class='es-highlighter'>{{item.full_name[0]}}</span>
                    </template>
                    <template v-else-if="searchIngCompanyList[item.index].full_name.indexOf(userFormNew.company_name) >-1">
                      <span v-for="(sitem,sindex) in item.full_name" :key="String(sindex)"><span class='es-highlighter' v-if="sindex == item.full_name.length-1">{{userFormNew.company_name}}</span>{{sitem}}</span>
                    </template>
                    <template v-else>
                      {{item.full_name[0]}}
                    </template>
                  </div>
                  <div class="name" v-else>
                    <span class='es-highlighter'>{{userFormNew.company_name}}</span>
                  </div>
                </template>
              </el-autocomplete>
              <div v-if="userInfo.status == 2" class="company-status">审核中</div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.company_name && userInfo.status == 0">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.company_name}}</span>
              </div>
            </dd>
          </dl>
          <dl class="formItem flex">
            <dt class="f_14 color_60"><span>公司邮箱</span>：</dt>
            <dd class="flex1">
              <div v-if="userFormNew.company_email && userInfo.status == 2" class="company f_14 color_40 flex disable-input">
                <p class="flex1 ellipsis">{{userInfo.cust_company_email || userFormNew.company_email}}</p>
                <!-- <p class="color_blue cursor_p" @click="bindEmailCreatedHr('edit')">去编辑</p> -->
              </div>
              <div class="restInput button f_14 cursor_p" :class="[userFormNew.company_email? 'color_40': 'placeholder']" v-else @click="bindEmailCreatedHr()" >{{ userFormNew.company_email || '请输入你的公司邮箱'}}</div>
            </dd>
          </dl>
        </div>
        <div :class="{'btn-disable' : userInfo.status == 2}" class="submitButton cursor_p color_fff text_center bg_current f_16" @click="confirmForm()">下一步</div>

      </div>
      <div class="pageTips text_center f_14 color_9c" v-if="stepId===0 || stepId===1">注册成功后即可免费下载候选人简历，无限邀约 <span @click="errorMessage" class="customer">联系客服</span></div>

      <!-- 注册成功 -->
      <div class="isOk bg_fff" v-if="stepId===2">
        <div class="top text_center">
          <div class="title f_18 color_40 font_w_b">注册成功！</div>
          <div class="text f_14 color_9c">500万人才正在期待您发布职位</div>
        </div>
        <img src="https://files.wondercv.com/hr_frontend/bindUser_pic1.png">
        <div class="submitButton cursor_p color_fff text_center bg_current f_16" @click="routerBack()">立即体验</div>
      </div>
      <!-- 审核公司 -->
      <div class="company-audit" v-if="stepId == 3">
        <companyAudit :email="this.$route.query.email" v-if="stepId == 3" :company_name="getCompanyName" @goback="goBack" :status="companyStatus" :audit_id="audit_id"></companyAudit>
      </div>
    </div>
    <!-- 只绑定手机号 -->
    <!-- <div class="onlyPhone bg_fff pa" v-if="pageType === 1">
      <img src="https://files.wondercv.com/hr_frontend/hr-logo1.png" class="logo" alt="">
      手机号样式
      <div class="phoneFormBox">
        <div class="formItem flex-c">
          <div class="phoneType f_14 color_40">+86</div>
          <div class="pr flex1">
            <input type="text" class="input f_16 color_40" v-model="phoneData.phone" placeholder="输入手机" maxlength="11">
          </div>
        </div>
        <div class="formItem flex-c">
          <div class="flex1 pr">
            <input type="text" class="input f_16 color_40" v-model="phoneData.phone_token" placeholder="请输入验证码" maxlength="6" >
          </div>
          <div class="getCode cursor_p text_center f_14">
            <span class="color_blue" @click="checkCode()" v-if="phoneData.time === 60">发送验证码</span>
            <span class="color_blue" v-else >重新获取({{phoneData.time}}s)</span>
          </div>
        </div>

        <div class="submitButton cursor_p color_fff text_center bg_current f_16" @click="updateInfo()">确认绑定</div>
        <div class="errorMessage f_14 color_9c" @click="errorMessage">登录遇到问题?</div>
      </div>
    </div> -->
    <div class="onlyPhoneBox pr" v-if="pageType === 1">
      <div class="signinBox pa clearfix">
        <div class="swapper fl">
          <el-carousel height="454px" autoplay :interval="10000" indicator-position="none">
            <el-carousel-item v-for="(item,index) in swapper" :key="index">
              <img :src="item" alt="超级简历" srcset="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="signin-content fr bg_fff">
          <div class="header">
            <div class="title f_16 color_40 font_w_b">绑定联系方式</div>
            <div class="text f_14 color_9c">便于快捷登录及人才沟通</div>
          </div>
          <div class="phoneFormBox">
            <div class="formItem">
              <input type="text" class="input f_16 color_40" v-model="phoneData.phone" placeholder="输入手机" maxlength="11">
            </div>
            <div class="formItem flex-c">
              <div class="flex1 pr">
                <input type="text" class="input f_16 color_40" v-model="phoneData.phone_token" placeholder="请输入验证码" maxlength="6" >
              </div>
              <div class="getCode cursor_p text_center f_14">
                <span class="color_blue" @click="checkCode()" v-if="phoneData.time === 60">发送验证码</span>
                <span class="color_blue" v-else >重新获取({{phoneData.time}}s)</span>
              </div>
            </div>

            <div class="submitButton cursor_p color_fff text_center bg_current f_16" @click="updateInfo()">继续</div>
            <div class="errorMessage f_14 color_9c" @click="errorMessage">登录遇到问题?</div>
          </div>

        </div>
      </div>
    </div>

    <!-- 绑定邮箱弹层 -->
    <div class="bindEmailTips" v-if="showBindEmailState && stepId===1">
      <div class="tipsContent pa bg_fff">
        <div class="tipsTitle f_18 color_40 font_w_b">公司邮箱验证</div>

        <div class="form">
          <dl class="formItem flex" :class="[errorTips.email?'errorTips':'']">
            <dt class="f_14 color_60"><span>公司邮箱</span>：</dt>
            <dd class="flex1">
              <el-input class="restInput f_14 color_40" v-model="emailData.email" placeholder="请输入你的公司邮箱" @focus="inputFocus('email')" :maxlength="64" ></el-input>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.email">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.email}}</span>
              </div>
            </dd>
          </dl>
          <dl class="formItem flex" :class="[errorTips.code?'errorTips':'']">
            <dt class="f_14 color_60"><span>验证码</span>：</dt>
            <dd class="flex1">
              <div class="codeBox flex-c">
                <el-input class="restInput f_14 color_40 flex1" v-model="emailData.code" placeholder="请输入验证码" @focus="inputFocus('code')" :maxlength="6" ></el-input>
                <div class="time cursor_p text_center f_14">
                  <span class="color_blue" @click="getEmailCode()" v-if="emailData.time === 60">发送验证码</span>
                  <span class="color_90" v-else >{{emailData.time}}s</span>
                </div>
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.code">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.code}}</span>
              </div>
            </dd>
          </dl>
<!--          <div class="bindEmailCode f_14 color_9c"><span class="cursor_p" @click="showEmailBind">无法收到验证码？</span></div>-->
          <div class="bindEmailCode f_14 color_9c"></div>
        </div>
        <div class="formButtons clearfix">
          <div class="fr confirm text_center bg_current color_fff f_14 cursor_p" @click="bindEmail()">确定</div>
          <div class="fr cancel text_center color_60 f_14 cursor_p" @click="cancelBindEmail();">取消</div>
        </div>
      </div>
    </div>

    <userBindEmail v-if="emailBindState && stepId===1" :email='emailData.email' :errorState="emailBindErrorState"
    @hideUserBindEmailState="hideUserBindEmailState" @confirm="bindEmailConfirm" @hideEmailBindError='hideEmailBindError' />

    <!-- 询问框 -->
    <MessageBox :pageData="MessageBoxData" v-if="MessageBoxState" @confirmButton="confirmButton" @cancelButton="MessageBoxState = false;" />
    <MessageBox :pageData="sMessageBoxData" v-if="sMessageBoxState" @close="sMessageBoxState = false;" @confirmButton="toCompanyAudit(true)" @cancelButton="bindEmailCreatedHr('edit')" />
  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'

import { mapState, mapMutations } from 'vuex'
import { getValLenngth, isToggleUser, get_tUser, updateJWT } from '@/utils/utils'
import companyAudit from '@/components/companyAudit/index.vue'
import userBindEmail from '@/components/block/UserBindEmail'
import MessageBox from '@/components/block/MessageBox'
import { uuid } from 'vue-uuid';

export default {
  name: 'talentBinduser',
  data(){
    return {
      getUserDataState:false, //获取用户信息进度
      pageType:0, //0，绑定手机号/用户信息/完成，1，只绑定手机号
      isLoading:true,
      stepId:0, //当前第几步
      userJWT:{},
      bindData:{ //用户绑定信息
        phone: "",
        phone_is_bound: false,
        wechat_is_bound: false
      },
      userInformation:{ //表单数据集合
        name: '',
        company: '',//页面显示的公司名
        company_token: '', //选择的公司id
        company_name: '', //选择的公司名
        cust_company_name: '', //自己填的公司名
        company_position:'', //职位
        company_email: '',
      },
      // 表单数据（新）
      userFormNew: {
        company_name: '',
        name: '',
        company_position: '',
        company_email: ''
      },
      userInfo:{},//备份的用户数据
      phoneData:{ //绑定手机号参数
        phone:'',
        phone_token:'',
        time:60,
        getCodeState:false,
      },
      requestState:false,//接口请求的状态
      timeName:null, //邮箱倒计时

      emailData: {
        time:60,
        timeName:null,
        email:'',
        code:'',
        getCodeState:false,
      },
      errorTips:{ //表单错误提示集合
        email: '',
        code:'',
        company_name:'公司信息审核未通过，请重新填写'
      },
      editModule:{ //单独编辑合集
        user:false,//用户信息
        company:false,//公司编辑
        email:false, //邮箱
      },
      showBindEmailState:false,
      cannotEmail:['@qq.com','@163.com','@126.com','@gmail','outlook.com','@hotmail.com','.edu','@sohu.com','@sina.com'],//不能输入的邮箱
      backToIndex:false,//是否返回主页
      link_to:'',
      emailBindState:false,//手动绑定弹层显示状态
      emailBindEdit:'',//是否是修改邮箱
      emailBindErrorState:false,//错误状态提示

      MessageBoxState:false,//是否显示错误框
      sMessageBoxState:false,//是否显示错误框
      MessageBoxData:{
        title:'绑定失败',
        desc:'账号已有过操作记录，请联系客服绑定',
        confirmText:'联系客服',
        cancelText:'关闭',
      },
      sMessageBoxData:{
        title:'认证失败',
        desc:'请使用正规邮箱进行员工身份的认证，或者通过上传营业执照进行认证',
        confirmText:'上传营业执照',
        cancelText:'修改邮箱',
        confirmButtonBg: '#FF6644',
        showClose: true
      },
      swapper:['https://files.wondercv.com/auth_frontend/banner1.png','https://files.wondercv.com/auth_frontend/banner2.png','https://files.wondercv.com/auth_frontend/banner1.png','https://files.wondercv.com/auth_frontend/banner2.png'],
      searchIngCompanyList:[],
      qrCodeQuery:{ // 获取二维码参数
        scene_str:'bind_' + uuid.v1(), //场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
        account_type:'hr_account', //账户种类 hr_account 或 cv_account
        operation_type:'bind', //是	bind/login 目前只用bind逻辑
        expire_seconds:60, //二维码有效期
      },
      qrCodeData:{ //二维码参数
        url:'',
        checkSize:57/3, // 轮训次数
      },
      qrCodeTimeoutName:null, // 微信登录轮训定时器
      headerType: 'bindPhone',  // header 类型：bindPhone qrcode
      isEditCompanyEmail: false, // 是否是编辑公司邮箱
      companyStatus: '', // 公司审核状态
      audit_id: '', // 审核表id
      nextLoading: false
    }
  },
  computed:{
    ...mapState('block', ['userInfoState', 'userinfoTipsState']),
    getCompanyName: function(){
      // 从更换邮箱页面进入需要传当前用户已经绑定的公司名称
      if(!!this.$route.query.bindCompany){
        return this.userInfo.company_name
      }
      // 更换公司页面进入 
      else if(!!this.$route.query.newCompanyName){
        return this.$route.query.newCompanyName
      }
      // 注册页
      else{
        return this.userFormNew.company_name
      }
    }
  },
  components:{
    userBindEmail,
    MessageBox,
    companyAudit
  },
  async created(){
    let { backToIndex, link_to } = this.$route.query;

    this.backToIndex = backToIndex || false;
    this.link_to = link_to || '';
    this.userJWT = get_tUser();
    console.log(this.userJWT,'ishr');
    //获取用户绑定信息
    this.getUsersBindInfo();
    setTimeout(() => {
      // 启动Udesk
      this.loadUdesk();
    }, 1000);
  },
  mounted() {
    try {
        document.getElementsByTagName('body')[0].className += 'hide-udesk-w0'
      } catch (error) {}
    },
  methods:{
    ...mapMutations('block',['toggleUserInfoState','toggleUserinfoTips','updateUserBindEmailState']),
    ...mapMutations('userBindInfo',['setBindInfo']),
    goBack(){
      this.stepId = 1
      this.getUserinfo('goback');
    },
    //【邮箱】获取验证码
    getEmailCode(){
      //防抖
      if(this.emailData.getCodeState){
        return false;
      }
      //对电子邮件的验证
      var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
      if(!myreg.test(this.emailData.email)){
        this.errorTips.email = '请填写有效的公司邮箱';
        return false;
      }
      this.emailData.getCodeState = true;
      let data={
        receiver: this.emailData.email,
        type: 'email',
        source: 'audit'
      }
      //发送验证码
      actions.hr_accounts.verification_codes(data).then(res=>{
        if(res.code === 1000){
          this.$message({
            message: '邮箱验证码已发送',
            type: 'success'
          });
          this.emailData.time = 59;
          this.codeTime();
        }else{
          this.emailData.getCodeState = false;
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //【邮箱】保存
    bindEmail(){
      //对电子邮件的验证
      var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
      if(!myreg.test(this.emailData.email)){
        this.errorTips.email = '请填写有效的公司邮箱';
        return false;
      }
      if(!this.emailData.code || this.emailData.code.length !=6){
        this.errorTips.code = '请输入正确的验证码';
        return false;
      }
      if(!this.isEditCompanyEmail) {
        //创建hr账户
        actions.auth.createHrAccount({
          company_email: this.emailData.email,
          email_code: this.emailData.code ,
          source : 'pc_browser'
        }).then(async res => {
          if(res.code == 1000) {
            let { jwt, jwt_timestamp } = res.data;
              await updateJWT({
              jwt,
              jwt_timestamp: jwt_timestamp
            });
            this.$message({
              message: '绑定成功',
              type: 'success'
            });
            this.userFormNew.company_email = this.emailData.email
            this.showBindEmailState = false;
          } else {
            this.errorTips.code = '请输入正确的验证码';
          }

        })
      } else { // 更换邮箱
        let data = {
          company_email: this.emailData.email,
          email_code: this.emailData.code,
        }
        actions.hr_accounts.company_emails(data).then(res => {
          if(res.code == 1000) {
            this.$message({
              message: '绑定成功',
              type: 'success'
            });
            this.userFormNew.company_email = this.emailData.email
            this.showBindEmailState = false;
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })
      }
    },
    // 去公司审核
    toCompanyAudit(showDialog){
      this.stepId = 3
      if(!!showDialog){
        this.sMessageBoxState = false
      }
    },
     //显示绑定邮箱弹框
    bindEmailCreatedHr(type) {
      if(type == 'edit'){
        if(!!this.emailData.timeName){
          clearInterval(this.emailData.timeName)
        }
        this.emailData = {
          time:60,
          timeName:null,
          email:'',
          code:'',
          getCodeState:false,
        };
      }
      this.isEditCompanyEmail = type == 'edit' ? true : false
      this.showBindEmailState = true;
      this.sMessageBoxState = false
    },
    //保存表单
    async confirmForm(checkEmail){
      if(this.userInfo.status == 2) return
      let { name, company_name, company_position, company_email } = this.userFormNew;
      if(!name){
        this.$message({
          message: '请输入真实姓名',
          type: 'success'
        });
        return false;
      }
      if(getValLenngth(name)>20){
        this.$message({
          message: '请输入正确的真实姓名',
          type: 'success'
        });
        return false;
      }
      if(!company_position){
        this.$message({
          message: '请输入职位名称',
          type: 'success'
        });
        return false;
      }
      if(!company_name){
        this.$message({
          message: '请输入公司名称',
          type: 'success'
        });
        return false;
      }
      if(!company_email){
        this.$message({
          message: '请填写公司邮箱',
          type: 'success'
        });
        return false;
      }
      if(this.nextLoading) {
        return
      }
      this.nextLoading = true
      let loading = this.$message({
          message: '正在加载',
          iconClass:'el-icon-loading',
          duration:0,
      });
      // 保存用户信息以及邮箱校验
      actions.hr_accounts.audition_email({
        company_name,
        name,
        profession: company_position,
        email: company_email
      }).then(res => {
        // console.log(res.message == '成功','ressss');
        this.nextLoading = false
        loading.close()
        if(res.code === 1000 && res.data && res.data.message === '公司不在数据库') {
          // 去公司审核页
          this.toCompanyAudit(false)
        } else if(res.code !== 1000 && (res.message === '非企业邮箱' || res.message === '邮箱格式有误')){
          // 修改邮箱或者去审核页
          this.sMessageBoxState = true
        } else if(res.code === 1000 && res.message === '成功') {
          this.$message.success('绑定成功')
          this.$router.push('/talent/recommend')
        }
        if(res.code !== 1000) {
          this.$message.error('出错了')
        }
      }).catch(e => {
        this.nextLoading = false
        console.log(e);
      })
      return false
    },
    //【微信】获取二维码
    getQrcode(){
      //轮训倒计时
      this.qrCodeData.checkSize = 57/3;
      //清除定时器
      clearInterval(this.qrCodeTimeoutName);

      //获取二维码接口
      actions.auth.getWechatsQrcode(this.qrCodeQuery).then(res=>{
        if(res.code === 1000){
          this.qrCodeData.url = res.data.url;
          //轮训倒计时
          this.qrCodeData.checkSize = 57/3;
          // 【微信】检测是否登录
          this.checkWechatLogin();
        }else{
          this.$message.error(res.message);
        }
      })

    },
    //【微信】检测是否扫码
    checkWechatLogin(){
      this.qrCodeTimeoutName = setInterval(() => {
        this.getWechatJwtverify();
        this.qrCodeData.checkSize = this.qrCodeData.checkSize-1;
        if(this.qrCodeData.checkSize<1){
          clearInterval(this.qrCodeTimeoutName);
        }
      }, 3000);
    },
    //【微信】验证是否扫码
    getWechatJwtverify(){
      let query = {
        scene_str: this.qrCodeQuery.scene_str,
        operation_type:'bind',
      }
      actions.auth.getWechatsQrcodeResult(query).then(async res=>{
        if(res.code === 1000){
          if(!!res.data && !!res.data.jwt && !!res.data.jwt_timestamp){
            let { jwt, jwt_timestamp } = res.data;
            await updateJWT({
              jwt,
              jwt_timestamp: jwt_timestamp
            });
          }
          this.$message({
            message: '微信绑定成功',
            type: 'success'
          });
          window.location.reload()
          //重新设置新的uuid
          this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();

          // 绑定成功后跳转到第二步骤
          this.stepId = 1
        }else{
          if(res.code === 200101 || res.code === 200203){
            //此微信已经绑定别的账户
            this.$message({
              message: res.message,
              type: 'error'
            });
            //重新设置新的uuid
            this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();
            // 绑定成功后跳转到第二步骤
            this.stepId = 1
          }
        }
      })
    },
    //【微信】关闭二维码
    hideBindQrcode(){
      this.qrCodeData = { //二维码参数
        url:'',
        checkSize:57/3, // 轮训次数
      };
      clearInterval(this.qrCodeTimeoutName);
    },
    //获取用户绑定信息
    async getUsersBindInfo(){
      actions.auth.getUserBind(this.userJWT.t).then(async res=>{
        this.isLoading = false;
        if(res.code === 1000){
          this.bindData = res.data;

          // console.log(this.bindData,"================>bind info")
          this.setBindInfo(this.bindData)
          if(res.data.phone_is_bound){
            this.stepId = 1
          }
          // 已经是hr了
          if(this.userJWT.h_t){
            // 获取用户信息
            this.getUserinfo();
          }else{
            //获取用户信息进度
            this.getUserDataState = true;
          }
        }
      })
    },
    // 获取用户信息
    async getUserinfo(type){
      let userInfo = await actions.hr_accounts.getUserinfo();
      this.toggleUserInfoState(userInfo);
      this.userInfo = {...userInfo};
      this.userInformation = {
        company: userInfo.company_name,
        ...userInfo
      };
      this.userFormNew.name = this.userInfo.name
      this.userFormNew.company_name = this.userInfo.cust_company_name
      this.userFormNew.company_position = this.userInfo.company_position
      this.userFormNew.company_email = this.userInfo.company_email
      this.companyStatus = this.userInfo.status
      this.audit_id = this.userInfo.audit_id
      if(type == 'goback') { // 从公司审核返回
        return
      }
      // 更换公司来的进入审核页面
      if(this.$route.query.fromEditUserInfo){
        this.stepId = 3
      }
      else if(this.userInfoState && this.bindData.phone_is_bound){
        //全部完善了
        this.routerBack();
        return false;
      }
      else if(!this.bindData.phone_is_bound && this.userInfoState){
        //已完善信息，直接显示只绑定用户手机号页面
        this.pageType = 1 ;
      }else if(!this.userInfoState){
        if (!this.bindData.phone_is_bound) {
          this.stepId = 0
        } else if (!this.bindData.wechat_is_bound && this.userInfo.status == 3) {
          this.stepId = -1
          this.headerType = 'qrcode'
          this.getQrcode()
        } else {
          this.stepId = 1
        }
        // this.stepId = !this.bindData.phone_is_bound ? 0 : -1;
      }

      // 完善完信息&& 已经有有手机号 ? 显示进度条 ：（完善完信息 ？ 只绑定手机号 ： 显示进度条）
      //获取用户信息进度
      this.getUserDataState = true;
    },

    //获取验证码 手机号
    checkCode(){
      let { phone, phone_token, getCodeState } = this.phoneData; //绑定手机号参数
      if(getCodeState){
        return false;
      }
      if(!phone){
        this.$message({
          message: '请输入手机号',
          type: 'success'
        });
        return false;
      }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
        this.$message({
          message: '请输入正确的手机号',
          type: 'success'
        });
        return false;
      }
      this.getPhoneCode();
    },
    //【手机】获取短信验证码-接口
    getPhoneCode(){
      let { phone, phone_token, getCodeState } = this.phoneData; //绑定手机号参数
      if(getCodeState){
        return false;
      }
      this.phoneData.getCodeState = true;
        let query = {
          phone_number:phone,
          premise:'hr_account_bind',
        }
        actions.auth.getPhoneCode(query).then(res=>{
          if(res.code === 1000){
            this.$message({
              message: '获取验证码成功',
              type: 'success'
            });
            this.phoneData.time = 59;
            this.getPhoneCodeTime();
          }else{
            this.phoneData.getCodeState = false;
            if(res.code === 2002 || res.code === 200101){
              this.MessageBoxState = true;
              return false;
            }
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })
    },
    //【手机】倒计时
    getPhoneCodeTime(){
      this.timeName = setInterval(() => {
        if(this.phoneData.time == 1){
          clearInterval(this.timeName);
          this.phoneData.time = 60;
          this.phoneData.getCodeState = false;
          return false;
        }
        this.phoneData.time = this.phoneData.time-1;

      }, 1000);
    },
    //【手机】绑定用户信息前的验证 手机号/邮箱
    async updateInfo(){
      let { phone, phone_token} = this.phoneData; //绑定手机号参数
      let bindSuccessText = '';

      if(!phone){
        this.$message({
          message: '请输入手机号',
          type: 'success'
        });
        return false;
      }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
        this.$message({
          message: '请输入正确的手机号',
          type: 'success'
        });
        return false;
      }
      if(!phone_token || phone_token.length!==6){
        this.$message({
          message: '请输入正确的验证码',
          type: 'success'
        });
        return false;
      }
      let data = {
        operation_type:'hr_bind_phone',
        phone_number:phone,
        phone_code:phone_token
      };
      actions.auth.updateUserBind(this.userJWT.t, data).then(async res=>{
        if(res.code === 1000){
          if(!!res.data){
            let { jwt, jwt_timestamp } = res.data;
              await updateJWT({
                jwt,
                jwt_timestamp: jwt_timestamp
              });
          }
          this.$message({
            message: '手机号绑定成功',
            type: 'success'
          });
          window.location.reload()
          if(this.pageType === 1){
            //已经完善完信息 直接读取返回的url
            setTimeout(() => {
              this.routerBack();
            }, 1000);
          }else{
            //进入创建用户/保存用户信息
            this.stepId = 1;
          }

        }else{
          this.phoneData.getCodeState = false;
          if(res.message == "验证失败: Phone已经被使用" || res.code === 2002){
            this.MessageBoxState = true;
            return false;
          }
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },

    //【公司】搜索公司名称
    companySearch(queryString,cb) {
      queryString = queryString ? queryString.trim() : '';
      this.company = queryString;
      this.userInformation.company = queryString;
      if(!queryString){
        cb([]);
        return false;
      }
      let query = {
        from:0,
        size:30,
        keyword:queryString
      }
      actions.company.get_company_name(query).then(res=>{
        if(res.code === 1000){
          let { companies } = res.data;
          this.searchIngCompanyList = JSON.parse(JSON.stringify(companies));
          //防止同指针，污染 searchIngCompanyList
          let companyList = [...companies];
          //拆分数据
          companyList.forEach((item,index)=>{
            let name = [item.full_name];
            if(item.full_name.indexOf(queryString)>-1){
              name = item.full_name.split(queryString).filter(sitem => sitem)
            }
            item.index = index;
            item.full_name = name
          })
          // console.log(companyList)
          // 调用 callback 返回建议列表的数据
          cb(companyList);
        }
      })

    },
    //【公司】点击城市筛选项
    handleCompany(item) {
      this.userFormNew.company_name = this.searchIngCompanyList[item.index].full_name;
    },
    //【公司】失焦，如果匹配不上，直接情况输入框
    companyBlur(){
      let company = this.userInformation.company ? this.userInformation.company.trim() : '';
      let hasCompany = false;
      if(!company){
        this.userInformation.company = ''
        return false;
      }
      this.searchIngCompanyList.forEach(item=>{
        if(item.full_name === company){
          hasCompany = true;
        }
      })
      if(!hasCompany){
        this.userInformation.company = '';
      }
    },

    //提交表单
    submitForm(){
      //判断填写的公司名称是否是库里包含的
      if(!this.userInformation.company_token && this.searchIngCompanyList.length){
        let company = {}
        this.searchIngCompanyList.forEach(item=>{
          if(item.full_name === this.userInformation.company || !item.full_name.length){
            company = item;
          }
        })
        if(company.full_name){
          this.userInformation.company_token = company.token; //选择的公司id
          this.userInformation.company_name = ''; //自己填的公司名/
        }else{
          this.userInformation.company = '';
          this.userInformation.company_token = ''; //选择的公司id
          this.userInformation.company_name = ''; //自己填的公司名
          this.$message({
            message: '请输入正确的公司全称',
            type: 'success'
          });
          return false;
        }
      }
      this.userInformation.source = 'pc_browser';

      //判断是否更换用户
      let toggleUserData = isToggleUser();
      if(toggleUserData.state){
        console.log('更换了用户=====================》')
        //刷新页面
        location.reload();
        return false;
      }
      // 完善hr信息（创建hr或仅完善hr信息）
      this.updateUser(this.userInformation);
      // if(!this.userJWT.h_t){
      //   //不是hr，保存时走创建用户信息
      //   this.creatUser(this.userInformation);
      // }else{
      //   //是hr，走更新方法
      //   this.updateUser(this.userInformation);
      // }
    },
    //完善hr信息（创建hr或仅完善hr信息）
    updateUser(data){
      let { email, code} = this.emailData;
      let submitData = JSON.parse(JSON.stringify(data));
      if(email){
        submitData.company_email = email;
        submitData.email_code = code;
      }
      //没有保存邮箱，直接删除参数
      if(!this.showBindEmailState){
        delete(submitData.company_email)
      }

      actions.hr_accounts.update_user(submitData).then(async res=>{
        //正在loading
        this.updateUserBindEmailState(false);
        if(res.code === 1000){
          //跳过之后，执行刷新jwt功能
          let { jwt, jwt_timestamp } = res.data;
          await updateJWT({
            jwt,
            jwt_timestamp: jwt_timestamp
          });
          this.userJWT = get_tUser();
          //更改数据
          this.userInformation.company_email = email;

          this.isLoading = false;
          this.$message({
            message: '用户信息绑定成功',
            type: 'success'
          });
          //关闭绑定邮箱弹层
          this.cancelBindEmail();
          // 绑定/注册成功，返回上一页面
          this.routerBack()
          //切换到绑定成功页面
          // this.stepId = 2;
        }else{
          this.isLoading = false;
          if(res.message==='系统未收到邮件，请重新发送邮件确认'){
            this.emailBindErrorState = true;
            return false;
          }
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //【反向绑定】切换显示状态
    hideUserBindEmailState(){
      this.emailBindState = false;
    },
    //【反向绑定】显示手动绑定邮箱弹层
    showEmailBind(){
      //对电子邮件的验证
      var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
      let hasCannotEmail = false;
      this.cannotEmail.forEach(item=>{
        if(this.emailData.email.indexOf(item)>-1){
          hasCannotEmail = true;
        }
      })
      if(hasCannotEmail || !myreg.test(this.emailData.email)){
        this.errorTips.email = '请填写有效的公司邮箱';
        return false;
      }
      //显示手动弹窗弹层
      this.emailBindState = true;
      //同步是否正在编辑邮箱
      this.emailBindEdit = this.editModule.email;
      //关闭绑定邮箱弹层
      this.cancelBindEmail();
      //检测邮箱是否重复
      // actions.hr_accounts.verification_emails({company_email:this.emailData.email}).then(res=>{
      //   if(res.code === 1000){
      //     //显示手动弹窗弹层
      //     this.emailBindState = true;
      //     //同步是否正在编辑邮箱
      //     this.emailBindEdit = this.editModule.email;
      //     //关闭绑定邮箱弹层
      //     this.cancelBindEmail();
      //   }else{
      //     this.$message({
      //       message: res.message,
      //       type: 'error'
      //     });
      //   }
      // })
    },
    //【反向绑定】绑定邮箱
    bindEmailConfirm(code){
      //正在loading
      this.updateUserBindEmailState(true)

      if(this.emailBindEdit){
        //走另一种方式
        // this.updateData('email')
        //判断填写的公司名称是否是库里包含的
        let { email } = this.emailData;
        let data = {
          company_email: email,
          email_code: code,
        }
        this.company_emails(data,(type)=>{
          //正在loading
          this.updateUserBindEmailState(false)
          if(type){
            this.emailBindErrorState = true;
            return false;
          }
          this.editModule[email] = false;
          this.userInformation.company_email = email;
          this.userInformation.email_code = code;
          this.getUserinfo();
          //关闭绑定邮箱弹层
          this.hideUserBindEmailState();
        });
      }else{
        this.emailData.code = code
        //完善信息页面，之后，才能保存邮箱，然后直接保存
        this.submitForm();
      }
    },
    //【反向绑定】取消错误提示
    hideEmailBindError(){
      this.emailBindErrorState = false;
    },

    //单独保存公司
    company_emails(data,callback){
      actions.hr_accounts.company_emails(data).then(async res=>{
        if(res.code === 1000){
          this.$message({
            message: '用户信息绑定成功',
            type: 'success'
          });
          callback && callback()
        }else{
          if(res.message==='系统未收到邮件，请重新发送邮件确认'){
            callback && callback(true);
            return false;
          }
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //【邮箱】倒计时
    codeTime(){
      this.emailData.timeName = setInterval(() => {
        if(this.emailData.time == 1){
          clearInterval(this.emailData.timeName);
          this.emailData.time = 60;
          this.emailData.getCodeState = false;
          return false;
        }
        this.emailData.time = this.emailData.time-1;

      }, 1000);
    },
    //【邮箱】弹出邮箱弹层
    showEditEmail(){
      //完善信息才能保存邮箱
      this.emailData = {
        time:60,
        timeName:null,
        email:this.userInformation.company_email,
        code:'',
        getCodeState:false,
      }
      this.editModule.email = true;
    },
    //【邮箱】关闭
    cancelBindEmail(){
      this.showBindEmailState = false;
      this.editModule.email = false;
      if( this.emailData.time <= 0){
        this.emailData.getCodeState = false; //获取验证码的状态
        this.emailData.time=60;
      }
      // clearInterval(this.timeName);
    },
    //跳过
    routerBack(jump){
      //有返回首页参数，并且只能去搜索列表
      if(jump){
        window.location.href = '/talent/recommend';
        return false;
      }
      if(this.link_to){
        window.location.href = decodeURIComponent(decodeURIComponent(this.link_to));
      }else{
        window.location.href = '/talent/recommend'
      }
    },
    //【重复绑定提示框】联系客服
    confirmButton(){
      this.MessageBoxState = false;
      this.errorMessage();
    },
    //取消错误提示
    inputFocus(type){
      this.errorTips[type] = ''
      if(type === 'email'){
        this.errorTips.company_email = ''
      }
    },
    // 错误信息
    errorMessage(){
      let udesk_container = document.querySelector('#udesk_btn a');
      if(udesk_container!=null){
        udesk_container.click();
      }
    },
    /*
    //【单独】更新用户信息验证方法
    updateData(type){
      let { name, company, company_position, company_email, email_code } = this.userInformation;
      let formState = true;
      //判断是否更换用户
      let toggleUserData = isToggleUser();
      if(toggleUserData.state){
        //刷新页面
        location.reload();
        return false;
      }

      if(type === 'user'){
        if(!name){
          this.errorTips.name = '请输入真实姓名';
          formState = false;
        }
        if(getValLenngth(name)>20){
          this.errorTips.name = '请输入正确的真实姓名';
          formState = false;
        }
        if(!company_position){
          this.errorTips.company_position = '请输入职位名称';
          formState = false;
        }
        if(!formState){
          return false;
        }
        let data = {
          name,
          // phone,
          company_position
        }
        this.updateDataSubmit(data,()=>{
          this.editModule[type] = false;
          this.userInfo.name = name;
          // this.userInfo.phone = phone;
          this.userInfo.company_position = company_position;
        });
      }else if(type === 'company'){
        if(!company){
          this.errorTips.company = '请输入公司全称';
          formState = false;
        }
        let companyAry = ["某", "知名", "国内"];
        const companyIndex = companyAry.findIndex(
          val => company.indexOf(val) !== -1
        );
        if (companyIndex !== -1) {
          this.errorTips.company = '请输入正确的公司全称';
          formState = false;
        }
        if(!formState){
          return false;
        }
        //判断填写的公司名称是否是库里包含的
        let data = {
          company_token:'',
          company_name:'',
        }
        let companyData = {}
        this.searchIngCompanyList.forEach(item=>{
          if(item.full_name === company || !item.full_name.length){
            companyData = item;
          }
        })
        if(companyData.full_name){
          data.company_token = companyData.token; //选择的公司id
          data.company_name = ''; //自己填的公司名/
        }
        // else{
        //   data.company_token = ''; //选择的公司id
        //   data.company_name = company; //自己填的公司名
        // }
        this.updateDataSubmit(data,()=>{
          this.editModule[type] = false;
          if(companyData.full_name){
            this.userInfo.company_token = companyData.token; //选择的公司id
            this.userInfo.company_name = ''; //自己填的公司名/
          }else{
            this.userInfo.company_token = ''; //选择的公司id
            this.userInfo.company_name = company; //自己填的公司名
          }
          //切换到绑定成功页面
          this.stepId = 2;
        });
      }else if(type === 'email'){
        //判断填写的公司名称是否是库里包含的
        let { email, code } = this.emailData;
        let data = {
          company_email: email,
          email_code: code,
        }
        this.company_emails(data,()=>{
          this.editModule[type] = false;
          this.userInformation.company_email = email;
          this.userInformation.email_code = code;
        });
      }
    },
    //【单独】更新用户信息验证保存
    updateDataSubmit(data,callback){
      actions.hr_accounts.updateUserinfo(data).then(async res=>{
        //正在loading
        this.updateUserBindEmailState(false)
        if(res.code === 1000){
          this.$message({
            message: '用户信息绑定成功',
            type: 'success'
          });
          //关闭绑定邮箱弹层
          this.cancelBindEmail();
          callback && callback()
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    */
    // Udesk 启动客服
    async loadUdesk(){
      actions.udesk.udeskOnlineUrl({}).then(res=>{
        if(res.code === 1000){
          let { arr1, arr2 } = res.data;
          if(arr2){
            arr2 = {
              customer:arr2
            }
          }
          let udeskArray = Object.assign(arr1,arr2);
          //定时器启动
          setTimeout(() => {
            (function(a,h,c,b,f,g){
              a["UdeskApiObject"]=f;
              a[f] = a[f] || function(){(
                a[f].d=a[f].d||[]
                ).push(arguments)
              };
              g = h.createElement(c);
              g.async=1;
              g.charset="utf-8";
              g.src=b;
              c=h.getElementsByTagName(c)[0];
              c.parentNode.insertBefore(g,c)
            })(window,document,"script","//assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
            //传递信息
            ud(udeskArray);

          }, 1000);

        }
      });


    },
  }
}
</script>

<style lang="scss" scoped>

@import './Index.scss';
</style>
